import { memo } from 'react';
import { MemberRemoveContactFormTemplate } from 'components/templates/MemberRemoveContactFormTemplate';

type Props = {};

export const MemberRemoveContactForm = memo((_props: Props) => {
	return <MemberRemoveContactFormTemplate />;
});
